__turbopack_context__.v({
  "ToggleButtonGroup": "ToggleButtonGroup-module__0j-lzW__ToggleButtonGroup",
  "segmented": "ToggleButtonGroup-module__0j-lzW__segmented",
});
